import { QueryFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

/** One extracted value on a loan, shaped to resolve a form_json `source`
 *  binding directly -- by document type NAME + field NAME, not ids (ids are
 *  per-tenant cuid2; form_json is shared across tenants). */
export interface LoanExtractedValue {
  documentId?: string;
  documentTypeName?: string;
  documentCreatedAt?: string;
  fieldTypeName?: string;
  fieldValue: string | null;
  tableValue: unknown;
}

export interface GetLoanExtractedValuesParams {
  loanId: string;
}

const getLoanExtractedValues: QueryFunction<
  LoanExtractedValue[],
  ['/loans/extracted-values', GetLoanExtractedValuesParams]
> = async ({ queryKey }) => {
  const [, params] = queryKey;
  if (isMockServices()) return await mock([]);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    success: boolean;
    data: LoanExtractedValue[];
  }>(`/loans/${params.loanId}/extracted-values`, { method: 'GET' });

  return response.data?.data ?? [];
};

export default getLoanExtractedValues;
